import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=cd026710&scoped=true&"
import script from "./Blank.vue?vue&type=script&lang=ts&"
export * from "./Blank.vue?vue&type=script&lang=ts&"
import style0 from "./Blank.vue?vue&type=style&index=0&id=cd026710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd026710",
  null
  
)

export default component.exports